$.fn.autocomplete = function() {
  const main = $(this);
  const input = main.find('input[type="text"]');
  const autocompleteUrl = main.attr('data-autocompleteUrl');
  const searchUrl = main.attr('data-searchUrl');

  const debounceDelay = 300;
  let debouncer;
  const ignoredKeys = [9,13,16,17,18,19,20,27,91];
  let results = [];
  let outputObj = false;

  input.on('keyup', (e) => {
    const keyCode = e.keyCode || e.which;
    if (keyCode === 27) {
      e.preventDefault();
      removeOutputObj();
    }
    else if (keyCode === 38 || keyCode === 40) {
      e.preventDefault();
      if (!outputObj) {
        queueSearch();
      } else {
        navigateResults(keyCode === 38 ? 'up' : 'down');
      }
    }
    else if (keyCode === 13) {
      e.preventDefault();
      doSearch();
    }
    else if(!ignoredKeys.includes(keyCode)){
      queueSearch();
    }
  });

  input.on('focus', (e) => {
    search();
  });

  main.find('.mdi-magnify').on('click', (e) => {
    e.preventDefault();
    doSearch();
  });

  const doSearch = () => {
    const key = 'query';
    const rex = new RegExp(`{{\\s*${key}\\s*?}}`, 'img');
    const value = input.val();
    const tmpUrl = searchUrl.replace(rex, value);
    window.location.href = tmpUrl;
  }

  const queueSearch = (callback) => {
    clearTimeout(debouncer);
    debouncer = setTimeout(() => {
      search(callback);
    }, debounceDelay);
  }

  const search = (callback) => {
    const value = input.val();
    
    if (value.length < 2) {
      removeOutputObj();
      return false;
    }

    $.ajax({
      url: autocompleteUrl,
      method: 'GET',
      data: `query=${value}`,
      success: function(response) {
        results = response;
        compileResults();
        if (callback) {
          callback();
        }
      }
    })
  };

  const compileResults = () => {
    let output = results.map((item) => {
      let itemTemplate = `<li><a href="{{ href }}">{{ label }}</a></li>`;

      Object.keys(item).forEach((key) => {
        let rex = new RegExp(`{{\\s*${key}\\s*?}}`, 'img');
        itemTemplate = itemTemplate.replace(rex, item[key]);
      });
      return `${itemTemplate}`;
    }).join('\n');

    removeOutputObj(true);

    main.find('[data-role="output"]').append(outputObj = $(`<ul>${output}</ul>`));
    bindNavigation();
  }

  const navigateResults = (direction) => {
    if (!outputObj || !results.length) {return false;}
    if (direction === 'up') {
      outputObj.find('a:last').focus();
    } else {
      outputObj.find('a:first').focus();
    }
  }

  const bindNavigation = () => {
    const items = outputObj.find('a');

    $(document).off('click.autocomplete');
    $(document).on('click.autocomplete', (e) => {
      if( !$(e.target).parents('.header__search').length ) {
        removeOutputObj();
        $('body').off('click.autocomplete');
      }
    });
    
    items.on('keydown', function(e) {
      const keyCode = e.keyCode || e.which;
      let index = items.index($(this));
      
      if (keyCode === 27) {
        e.preventDefault();
        removeOutputObj();
        input.focus();
      }
      else if (keyCode === 38) {
        e.preventDefault();
        index = index - 1 < 0 ? items.length - 1 : index - 1;
        items.eq(index).focus();
      }
      else if (keyCode === 40) {
        e.preventDefault();
        index = index + 1 >= items.length ? 0 : index + 1;
        items.eq(index).focus();
      }
      else if (keyCode === 13) {
        e.preventDefault();
        input.val($(this).text()).focus();
        removeOutputObj();
      }
    });
  }

  const removeOutputObj = (onlyRemoveObject) => {
    outputObj ? outputObj.remove() : '';
    outputObj = false;
    if (!onlyRemoveObject) {
      results = [];
    }
  }

}